<template>
    <div ref="mapdiv">
        <div @click="showMap(page)" class="show-map cursor-pointer border border-green-600 mb-4
        tracking-wider font-bold text-center py-2 px-2 text-lg sm:text-xl text-white bg-green-600
         hover:bg-green-500 hover:border-green-700" v-if="!isMapVisible"
        >
            <template v-if="page === 'destination'">
                <span class="icon-location"></span> View Properties On Map
            </template>
            <template v-else>
                <span class="icon-location"></span> View Property On Map
            </template>
        </div>
        <destination-map-component class="travel-map"
                                   v-if="destinationMap"
                                   :property-markers="propertyMarkers"
                                   :user-level="userLevel"
                                   :results-bounds="resultsBounds"
                                   :location="location"
                                   :filter-json='filterJson'
        >
        </destination-map-component>
        <property-map-component class="travel-map"
                                v-if="propertyMap"
                                :property="property"
        >
        </property-map-component>
    </div>
</template>
<script>
export default {
    name: "LazyLoadMapComponent",
    props: ['propertyMarkers', 'userLevel', 'resultsBounds', 'location', 'filterJson', 'page', 'property', 'hideMap'],
    components: {
        DestinationMapComponent: () => import('./DestinationMapComponent.vue'),
        PropertyMapComponent: () => import('./PropertyMapComponent.vue')
    },
    data() {
        return {
            isMapVisible: false,
            windowWidth: null,
            destinationMap: false,
            propertyMap: false,
            observed: false
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(this.elementObserved);
        }

    },
    mounted() {
        if ('IntersectionObserver' in window) {
            this.observer.observe(this.$refs.mapdiv);
        } else {
            this.observed = true;
        }

    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        elementObserved(entries) {
            if (entries[0].intersectionRatio <= 0) return;
            this.observed = true;
            this.handleResize();

        },
        handleResize() {
            if (!this.hideMap) {
                this.windowWidth = window.innerWidth;
                if (this.windowWidth > 765) {
                    this.showMap(this.page)
                }
            }
        },
        showMap(data) {
            this.isMapVisible = true;
            if (data === 'destination' && this.observed === true) {
                this.destinationMap = true
            }
            if (data === 'property' && this.observed === true) {
                this.propertyMap = true
            }

        }
    },
}
</script>
<style>
.no-webp .show-map {
    background-image: url(https://images.simplyowners.net/assets/view_map.png);
    background-size: cover;
}

.webp .show-map {
    background-image: url(https://images.simplyowners.net/assets/view_map.webp);
    background-size: cover;
}
</style>


